import React from 'react';

import TextInputField from 'components/layout/forms/TextInputField';
import { formatServerDateTime } from 'services/dates/serverTime';

const UpdatedField = ({
  label,
  updated,
  updatedUser,
}: {
  label: string;
  updated: null | string;
  updatedUser: any;
}): JSX.Element => {
  const getValue = () => {
    if (updated === null) {
      return '';
    }

    // In the time of the browser: the server sends UTC
    const date = formatServerDateTime(updated);

    if (updatedUser === null) {
      return date;
    }

    const { firstName, lastName } = updatedUser;
    return `${date}, ${firstName} ${lastName}`;
  };

  return <TextInputField disabled label={label} required value={getValue()} />;
};

export default UpdatedField;
